import loader from '../moduleLoader';
import animateScrollTo from 'animated-scroll-to';

class Tabs {
    constructor(tabsContainer) {
        this.tabsContainer = tabsContainer;
        this.tabContent == null;
        this.tabs = null;
        this.handleTabClick = this.handleTabClick.bind(this);
    }
    init() {
        this.tabContent = document.getElementById(this.tabsContainer.dataset.tabsFor);
        this.tabs = this.tabsContainer.querySelectorAll('.tab__control');
        Array.from(this.tabs).forEach((tab) => {
            tab.addEventListener('click', this.handleTabClick);
            if(tab.getAttribute('aria-selected') !== 'true') {
                tab.setAttribute('aria-selected', 'false');
            }
        })
        document.addEventListener('AllCollapsed', (e) => {
            Array.from(this.tabContent.children).forEach((content) => {            
                content.classList.add('hidden');
            })
            this.tabContent.children[0].classList.remove('hidden');
            this.deselectTabs();    
        }) 
    }
    handleTabClick(e) {
        e.preventDefault();
        var tab = e.target || e.srcElement;
        var contentForTab = document.getElementById(tab.getAttribute('aria-controls'));
        Array.from(this.tabContent.children).forEach((content) => {            
            content.classList.add('hidden');
        })
        this.deselectTabs();
        contentForTab.classList.remove('hidden');
        tab.setAttribute('aria-selected', 'true');
                
        animateScrollTo(contentForTab.getBoundingClientRect().top + (window.scrollY || window.pageYOffset) - 150);        
    }
    deselectTabs() {
        const allContainers = document.querySelectorAll(`[data-tabs-for=${this.tabsContainer.dataset.tabsFor}]`);
        Array.from(allContainers).forEach((container) => {
            const tabs = container.querySelectorAll('.tab__control');
            Array.from(tabs).forEach((tab) => {
                tab.setAttribute('aria-selected', 'false');
            })
        })
    }
}

loader.add('Tabs', Tabs);
export default Tabs;